import React, { useEffect, useState } from 'react';
import './vaasa-tulospalvelu-top.m.css';

const VaasaTulospalveluTop = () => {

  const [ippeData, setIppeData] = useState(null);
  const [openId, setOpenId] = useState(false);

  const toggle = (id) => {
    setOpenId(openId === id ? false : id);
  };

  useEffect(() => {
    const fetchIppeData = async () => {
      try {
        const response = await fetch(`/api/v1/authors/ippe`);
        const data = await response.json();
        setIppeData(data.author);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchIppeData();
  }, []);

  return (
    <div styleName="vaasa-ippe-top">
      <div styleName="author-bio">
        <div styleName="info">
          <h1>Vaasa-lehden tulospalvelu Ippe</h1>
          <div>Vaasa-lehden tulospalvelun tarjoaa tulosrobotti Ippe, joka tuottaa nopeasti tulosraportit otteluiden päättymisen jälkeen. Näet tulokset jääkiekon, salibandyn, pesäpallon ja jalkapallon niiden sarjatasojen otteluista, joissa pelaa joukkueita Vaasan seudulta.</div>
        </div>
      </div>
      <div styleName="button-row">
        <div styleName="sport">
          <button className="Pesäpallo" onClick={() => toggle('pesäpallo')}>
            <p>Pesäpallo</p><i className="ri-arrow-drop-down-line"></i>
          </button>
          {openId === 'pesäpallo' && (
            <ul styleName="serie-list">
              <li><a href="/vaasalehti/pesapallotulokset-mailattaret">Mailattaret</a></li>
              <li><a href="/vaasalehti/pesapallotulokset-laihian-luja">Laihian Luja</a></li>
              <li><a href="/vaasalehti/pesapallotulokset-vaasan-mailan-juniorit">Vaasan Mailan Juniorit</a></li>
              <li><a href="/vaasalehti/pesapallotulokset-vahakyron-viesti">Vähänkyrön Viesti</a></li>
              <li><a href="/vaasalehti/pesapallotulokset-vaasalehti">Katso kaikki</a></li>
            </ul>
          )}
        </div>
        <div styleName="sport">
          <button className="Futis" onClick={() => toggle('futis')}>
            <p>Jalkapallo</p><i className="ri-arrow-drop-down-line"></i>
          </button>
          {openId === 'futis' && (
            <ul styleName="serie-list">
              <li><a href="/vaasalehti/jalkapallotulokset-vps">VPS</a></li>
              <li><a href="/vaasalehti/jalkapallotulokset-vps-akatemia">VPS Akatemia</a></li>
              <li><a href="/vaasalehti/jalkapallotulokset-vifk">VIFK</a></li>
              <li><a href="/vaasalehti/jalkapallotulokset-vaasalehti">Katso kaikki</a></li>
            </ul>
          )}
        </div>
        <div styleName="sport">
          <button className="Salibandy" onClick={() => toggle('salibandy')}>
            <p>Salibandy</p><i className="ri-arrow-drop-down-line"></i>
          </button>
          {openId === 'salibandy' && (
            <ul styleName="serie-list">
              <li><a href="/vaasalehti/salibandytulokset-sb-vaasa">SB Vaasa</a></li>
              <li><a href="/vaasalehti/salibandytulokset-fyrry">Fyrry</a></li>
              <li><a href="/vaasalehti/salibandytulokset-vaasalehti">Katso kaikki</a></li>
            </ul>
          )}
        </div>
        <div styleName="sport">
          <button className="Jääkiekko" onClick={() => toggle('jääkiekko')}>
            <p>Jääkiekko</p><i className="ri-arrow-drop-down-line"></i>
          </button>
          {openId === 'jääkiekko' && (
            <ul styleName="serie-list">
              <li><a href="/vaasalehti/jaakiekkotulokset-sport">Sport</a></li>
              <li><a href="/vaasalehti/jaakiekkotulokset-sport-u20">Sport U20</a></li>
              <li><a href="/vaasalehti/jaakiekkotulokset-mif">MIF</a></li>
              <li><a href="/vaasalehti/jaakiekkotulokset-warrantti-mahtikukot">Warrantti Mahtikukot</a></li>
              <li><a href="/vaasalehti/jaakiekkotulokset-vaasalehti ">Katso kaikki</a></li>
            </ul>
          )}
        </div>
      </div>
    </div>
  );
}


export { VaasaTulospalveluTop };
